webpackJsonp([3],{

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(313),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-452bac2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      location: { lat: -36.894298, lng: 174.867250 }
    };
  }
});

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(289)(true);
// imports


// module
exports.push([module.i, ".contact-container[data-v-452bac2e]{padding-top:65px;min-height:100vh;padding-bottom:32px}.details[data-v-452bac2e]{width:100vw;max-width:400px;font-size:120%;text-align:left;padding-left:10px;color:#000;margin:auto}.map-container[data-v-452bac2e]{width:100vw;height:40vh;background:url(" + __webpack_require__(291) + ") no-repeat 50%;background-size:auto}.call-to-action-pitch[data-v-452bac2e]{font-size:120%;font-weight:600;text-align:left;padding:8px;margin-top:32px}@media screen and (min-width:767px){.call-to-action-pitch[data-v-452bac2e]{text-align:center}}", "", {"version":3,"sources":["/Users/tony/Desktop/projects/woods/src/components/Contact.vue"],"names":[],"mappings":"AACA,oCACE,iBAAkB,AAClB,iBAAkB,AAClB,mBAAqB,CACtB,AACD,0BACE,YAAa,AACb,gBAAiB,AACjB,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,WAAY,AACZ,WAAa,CACd,AACD,gCACE,YAAa,AACb,YAAa,AACb,uDAAwE,AACxE,oBAAsB,CACvB,AACD,uCACE,eAAgB,AAChB,gBAAiB,AACjB,gBAAiB,AACjB,YAAa,AACb,eAAiB,CAClB,AAED,oCACA,uCACI,iBAAmB,CACtB,CACA","file":"Contact.vue","sourcesContent":["\n.contact-container[data-v-452bac2e] {\n  padding-top: 65px;\n  min-height: 100vh;\n  padding-bottom: 32px;\n}\n.details[data-v-452bac2e] {\n  width: 100vw;\n  max-width: 400px;\n  font-size: 120%;\n  text-align: left;\n  padding-left: 10px;\n  color: #000;\n  margin: auto;\n}\n.map-container[data-v-452bac2e] {\n  width: 100vw;\n  height: 40vh;\n  background: url('../../static/img/preload.gif') no-repeat center center;\n  background-size: auto;\n}\n.call-to-action-pitch[data-v-452bac2e] {\n  font-size: 120%;\n  font-weight: 600;\n  text-align: left;\n  padding: 8px;\n  margin-top: 32px;\n}\n/*large screen*/\n@media screen and (min-width: 767px) {\n.call-to-action-pitch[data-v-452bac2e] {\n    text-align: center;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(303);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(290)("84e6b2a4", content, true);

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-container"
  }, [_c('div', [_c('gmap-map', {
    staticClass: "map-container",
    attrs: {
      "center": _vm.location,
      "zoom": 15
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.location,
      "clickable": true,
      "draggable": true
    },
    on: {
      "click": function($event) {
        _vm.center = _vm.location
      }
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "call-to-action-pitch"
  }, [_vm._v("Send me your building plans or the quantity in cubic meters you need and I will get you a price within 24 hours.")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_vm._v("\n    Email: "), _c('a', {
    attrs: {
      "href": "mailto:jonathan@siberianlarchwood.co.nz"
    }
  }, [_vm._v("jonathan@siberianlarchwood.co.nz")]), _c('br'), _c('br'), _vm._v("\n    Phone: "), _c('a', {
    attrs: {
      "href": "tel:0211098193"
    }
  }, [_vm._v("0211098193")]), _c('br'), _c('br'), _vm._v("\n    Address: "), _c('br'), _vm._v("81 Dunkirk Rd"), _c('br'), _vm._v("Panmure, Auckland, 1072\n  ")])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.01a61df14a3be7204603.js